export const treatmentPaymentAmount = (moneySign, treatment) => {
  if (treatment?.isPaid) return `${moneySign}${treatment?.price} / ${moneySign}${treatment?.price}`
  return `${moneySign}${treatment?.paidPrice} / ${moneySign}${treatment?.price}`
}

export const treatmentDebt = (moneySign, treatment) => {
  if (treatment?.isPaid) return `${moneySign}${0}`
  return `${moneySign}${treatment?.price - treatment?.paidPrice}`
}
